import { useEffect } from 'react';

/**
 * Redirect component for www.finderz.ai/login
 * Redirects to app.finderz.ai/login
 */
export const LoginRedirect = () => {
  useEffect(() => {
    // Check if we're on www.finderz.ai or finderz.ai
    const hostname = window.location.hostname;
    if (hostname === 'www.finderz.ai' || hostname === 'finderz.ai') {
      // Redirect to app.finderz.ai/login
      window.location.href = 'https://app.finderz.ai/login';
    }
  }, []);

  // Show loading state while redirecting
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm text-blue-600">
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Redirecting to login...
        </div>
      </div>
    </div>
  );
};
